/**
 * Resolve a usable Stripe publishable key.
 * Never fall back to a fake/placeholder key — that triggers Stripe Elements
 * wallet-config 401s and noisy DevTools errors without enabling payments.
 */

const PLACEHOLDER_KEYS = new Set([
  'pk_test_51O8e8febB65b434d967aDc4e816c4cf3',
  'pk_test_...',
  'pk_live_...',
]);

export function isUsableStripePublishableKey(key) {
  if (!key || typeof key !== 'string') return false;
  const trimmed = key.trim();
  if (!trimmed.startsWith('pk_test_') && !trimmed.startsWith('pk_live_')) return false;
  if (PLACEHOLDER_KEYS.has(trimmed)) return false;
  if (trimmed.includes('...')) return false;
  // Real Stripe publishable keys are long; short stubs are always invalid.
  if (trimmed.length < 80) return false;
  return true;
}

export function getStripePublishableKey() {
  const envKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
  if (isUsableStripePublishableKey(envKey)) return envKey.trim();

  if (typeof window !== 'undefined') {
    const fromConfig =
      window.config?.STRIPE_PUBLISHABLE_KEY ||
      window.APP_CONFIG?.SERVICES?.STRIPE_PUBLISHABLE_KEY;
    if (isUsableStripePublishableKey(fromConfig)) return fromConfig.trim();
  }

  return null;
}
